import { render, staticRenderFns } from "./StartupEditGeneral.vue?vue&type=template&id=105e421a&scoped=true"
import script from "./StartupEditGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupEditGeneral.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e421a",
  null
  
)

export default component.exports